export default __webpack_public_path__ + "static/fin-int-dig-pay-a3b31cde3ddbc64fb8dd8bd9f824057b.png";